import { fundsBonusSystemStates } from '../../../constants';
import { normalizeBsBonusDetails } from '../normalizeBsBonusDetails';

export const normalizeBsBonusesList = (
  bonuses,
  currency,
  filterBonusesByCurrency = true
) =>
  bonuses
    .filter(
      ({ status, currency: responseCurrency }) =>
        status !== fundsBonusSystemStates.CANCELED_BY_MANAGER &&
        (!filterBonusesByCurrency || responseCurrency.currency === currency)
    )
    .map((bonus) => normalizeBsBonusDetails(bonus, currency));
